<template>
  <div class="crumbs">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <i :class="[icon]"></i> {{ $t(parentTitle) }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t(childTitle) }}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="thildTitle">{{ $t(thildTitle) }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "boss-breadcrumb",
  props: {
    icon: {
      type: String,
      default: () => ''
    },
    parentTitle: {
      type: String,
      default: () => ''
    },
    childTitle: {
      type: String,
      default: () => ''
    },
    thildTitle: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped>
.crumbs {
  margin: 0 0 10px 10px;
}
</style>
